
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { useParams } from "react-router-dom";
import { CURRENT_CATEGORY } from '../redux/api/constants';
import { displayList } from './recipeList';
import withLayout from './withLayout';


function Categories() {
    const { id } = useParams();
    const dispatch = useDispatch()
    const currentCategoryRecipes = useSelector(state => state.API.currentCategoryRecipes);
    const currentCategoryTitle = useSelector(state => state.API.currentCategoryTitle);

    useEffect(() => {
        dispatch(doFetch(
            CURRENT_CATEGORY,
            `categories/${id}`
        ))
    }, [dispatch, id]);

    return (
        <div>
            <h1 className="mt-5">{currentCategoryTitle}</h1>
            {displayList(currentCategoryRecipes)}
        </div>
    );
}
export default withLayout(Categories);